(function($) {
    'use strict';
    var defaults = {
        navWrapTpl: '<div class="evin-wrap"></div>',
        topTableTpl: '<div class="evin-fixed-wrap top"><table></table></div>',
        topScrollStop: 500,
        topScrollShadowShowPosition: 1,
        topScrollTopOffset: 0,
        sideTableMinViewWidth: 640,

        sideTableTpl: '<div class="evin-fixed-wrap side"><table></table></div>',
        sideRightShadowTpl: '<div class="evin-shadow right"></div>',
        sideLeftShadowTpl: '<div class="evin-shadow left"></div>',
        sideScrollShadowShowPosition: 1,

        cornerTableTpl: '<div class="evin-fixed-wrap corner"><table></table></div>',
        rightArrowTpl: '<a class="btn btn-default evin-nav right"><em class="fa fa-chevron-right"></em></a>',
        leftArrowTpl: '<a class="btn btn-default evin-nav left"><em class="fa fa-chevron-left"></em></a>',
        removeClasses: '',
        addClasses: '',
        visibleClass: 'visible',
        fixedClass: 'fixed',
        scrollableWrap: null
    }

    //
    var BaseFixedTable = function (plugin, options) {
        var that = this;
        that.plugin = plugin;
        that.settings = options;
        that.$table = null;
    }
    BaseFixedTable.prototype.init  = function () {
        var that = this;
    }
    BaseFixedTable.prototype.onWindowScroll  = function () {

    }
    BaseFixedTable.prototype.onWindowResize  = function () {

    }
    BaseFixedTable.prototype.onWrapScroll  = function () {

    }
    BaseFixedTable.prototype.resize = function () {

    }
    BaseFixedTable.prototype.redraw = function () {

    }
    BaseFixedTable.prototype.createTable  = function (template) {
        var that = this;
        that.$wrap = $(template);
        that.$table = that.$wrap.find("table");
        that.$table.addClass(that.plugin.$table.attr("class"))
            .addClass(that.settings.addClasses)
            .removeClass(that.settings.removeClasses);
        that.plugin.$wrap.prepend(that.$wrap);
    }
    BaseFixedTable.prototype.isVisible = function () {
        var that = this;
        return that.$wrap.hasClass(that.plugin.settings.visibleClass);
    }
    BaseFixedTable.prototype.isFixed = function () {
        var that = this;
        return that.$wrap.hasClass(that.plugin.settings.fixedClass);
    }
    //==============================================
    var FixedCornerTable = function (plugin, options) {
        var that = this;
        BaseFixedTable.call(that, plugin, options);

        that.init(options.cornerTableTpl);
    }

    FixedCornerTable.prototype = Object.create(BaseFixedTable.prototype)

    FixedCornerTable.prototype.init = function (template) {
        var that = this;
        that.createTable(template);

        that.$tableCorner = that.plugin.$table.find(".corner");
        that.$fixedTableHead = that.plugin.$table.find("thead").clone();
        that.$fixedTableHead.find("th:not(.corner)").remove();
        that.$fixedTableCorner = that.$fixedTableHead.find(".corner");
        that.$table.append(that.$fixedTableHead);

        that.resize();
    }
    FixedCornerTable.prototype.resize = function () {
        var that = this;
        var tWidth = 0;
        //corner
        that.$tableCorner.each(function (index, el) {
            var elW = $(el).outerWidth();
            that.$fixedTableCorner.eq(index).css({
                width: elW,
                minWidth: elW,
                maxWidth: elW,
                height: $(el).outerHeight()
            })
            tWidth = elW;
        })
        that.$table.css({
            width: tWidth
        });
    }
    FixedCornerTable.prototype.onWindowScroll = function () {
        var that = this;
        that.checkVisibility();
        that.checkPosition();


    }
    FixedCornerTable.prototype.onWrapScroll = function () {
        var that = this;
        that.checkVisibility();
        that.checkPosition();
    }
    FixedCornerTable.prototype.checkPosition = function () {
        var that = this;
        if(!that.isFixed()){
            that.$wrap.css({
                top: that.plugin.fixedTopTable.$wrap.css("top"),
                left: that.plugin.fixedSideTable.left
            })
        }else{
            that.$wrap.css({
                left: that.plugin.$table.offset().left +  that.plugin.fixedSideTable.left
            });
        }
        if(this.topOffset != that.plugin.topOffset && that.isFixed()){
            that.updateFixedTop();
        }
    }
    FixedCornerTable.prototype.checkVisibility = function () {
        var that = this;
        //check visibility
        if(
            that.plugin.fixedTopTable.isVisible()
            && that.plugin.fixedSideTable.isVisible()
            && !that.isVisible()
        ){
            that.$wrap.addClass(that.plugin.settings.visibleClass);
        }else if(
            (
                !that.plugin.fixedTopTable.isVisible()
                || !that.plugin.fixedSideTable.isVisible()
            )
            && that.isVisible()
        ){
            that.$wrap.removeClass(that.plugin.settings.visibleClass + ' ' + that.plugin.settings.fixedClass);
        }
        //check fixing
        if(that.plugin.fixedTopTable.isFixed() && !that.isFixed()){
            that.$wrap.addClass(that.plugin.settings.fixedClass).css({
                top: that.plugin.topOffset,
                left: that.plugin.$table.offset().left +  that.plugin.fixedSideTable.left
            })
        }else if(!that.plugin.fixedTopTable.isFixed() && that.isFixed()){
            that.$wrap.removeClass(that.plugin.settings.fixedClass).css({
                top: that.plugin.fixedTopTable, left: 0
            })
        }

    }
    FixedCornerTable.prototype.updateFixedTop = function () {
        var that = this;
        that.$wrap.css({
            top: that.plugin.topOffset
        })
        that.topOffset = that.plugin.topOffset;
    }

    //===============================================
    var FixedSideTable = function (plugin, options) {
        var that = this;
        that.left = 0;
        BaseFixedTable.call(that, plugin, options);
        that.init(options.sideTableTpl);
    }
    FixedSideTable.prototype = Object.create(BaseFixedTable.prototype);

    FixedSideTable.prototype.init = function (template) {
        var that = this;
        that.createTable(template);

        that.cotainerScrollPos = 0;
        that.isTooNarrow = false;
        that.$tableCorner = that.plugin.$table.find(".corner");
        that.$tableBody = that.plugin.$table.find("tbody");
        that.$tableBodyThs = that.$tableBody.find("th");


        that.$navRight = $(that.plugin.settings.rightArrowTpl);
        that.plugin.$navWrap.append(that.$navRight);
        that.$navRight.on("click", function () {
            that.scrollWrap(that.plugin.$wrap.width()/2);
        })

        that.$navLeft = $(that.plugin.settings.leftArrowTpl);
        that.plugin.$navWrap.append(that.$navLeft);
        that.$navLeft.on("click", function () {
            that.scrollWrap(-that.plugin.$wrap.width()/2);
        })
        that.$rightShadow = $(that.plugin.settings.sideRightShadowTpl);
        that.plugin.$navWrap.append(that.$rightShadow);
        that.$leftShadow = $(that.plugin.settings.sideLeftShadowTpl);
        that.plugin.$navWrap.append(that.$leftShadow);
        that.redraw();
    }
    FixedSideTable.prototype.redraw = function () {
        var that = this;
        that.$table.html('');
        that.$fixedSideTableHead = that.plugin.$table.find("thead").clone();
        that.$fixedSideTableHead.find("th:not(.corner)").remove();
        that.$fixedSideTableCorner = that.$fixedSideTableHead.find(".corner");
        that.$table.append(that.$fixedSideTableHead);
        that.$fixedSideTableBody = that.$tableBody.clone();
        that.$fixedSideTableBody.find("td").remove();
        that.$fixedSideTableBodyThs = that.$fixedSideTableBody.find("th");
        that.$fixedSideTableBody.prepend(that.$fixedSideTableBody);
        that.$table.append(that.$fixedSideTableBody);

    }
    FixedSideTable.prototype.scrollWrap = function (offset) {
        var that = this;
        that.cotainerScrollPos += offset;
        that.cotainerScrollPos = Math.min(Math.max(0, that.cotainerScrollPos), that.plugin.$wrap[0].scrollWidth - that.plugin.$wrap.width());
        that.plugin.$wrap.stop().animate({scrollLeft: that.cotainerScrollPos});
    }
    FixedSideTable.prototype.resize = function () {
        var that = this;
        var tWidth = 0;

        //corner
        that.$tableCorner.each(function (index, el) {
            var elW = $(el).outerWidth();

            that.$fixedSideTableCorner.eq(index).css({
                width: elW,
                minWidth: elW,
                maxWidth: elW,
                height: $(el).outerHeight()
            })
            tWidth += elW;
        })

        that.$tableBodyThs.each(function (index, el) {
            var elW = $(el).width();
            that.$fixedSideTableBodyThs.eq(index).css({
                width: elW,
                height: $(el).outerHeight()
            });
        });

        that.$table.css({
            width: tWidth
        });

        if(that.isTooNarrow){
            that.$navLeft.css({
                left: 0
            });
            that.$leftShadow.css({
                left: 0
            });
        }else{
            that.$navLeft.css({
                left: tWidth
            });
            that.$leftShadow.css({
                left: tWidth
            });
        }
    }
    FixedSideTable.prototype.onWrapScroll = function () {
        var that = this;
        if(!that.isTooNarrow){
            if(
                that.$fixedSideTableBody.height() != that.$tableBody.height()
            ){
                that.resize();
            }

            that.left = that.plugin.wrapScrollPos;
            if(that.left > that.settings.sideScrollShadowShowPosition && !that.isVisible()){
                that.$wrap.addClass(that.plugin.settings.visibleClass);
            }else if(that.left < that.settings.sideScrollShadowShowPosition && that.isVisible()){
                that.$wrap.removeClass(that.plugin.settings.visibleClass);
            }
            that.$wrap.css({
                left:that.left
            });
        }

        that.checkNavVisibility();
    }
    FixedSideTable.prototype.onWindowScroll = function () {
        var that = this;
        that.alignNavDelay();
    }
    FixedSideTable.prototype.onWindowResize = function () {
        var that = this;
        that.isTooNarrow = $(window).width() <= that.plugin.settings.sideTableMinViewWidth;
        that.resize();
        that.onWrapScroll();

    }
    FixedSideTable.prototype.isNavFixed = function () {
        var that = this;
        return that.$navRight.hasClass(that.plugin.settings.fixedClass);
    }
    FixedSideTable.prototype.alignNavDelay = function () {
        var that = this;
        clearTimeout(that.alignNavTimeout)
        that.alignNavTimeout = setTimeout(function () {
            that.alignNav();
        }, 300)
    }
    FixedSideTable.prototype.checkNavVisibility = function () {
        var that = this;
        //left
        if(that.plugin.wrapScrollPos > that.settings.sideScrollShadowShowPosition && !that.leftShadowVisible){
            that.leftShadowVisible = true;
            that.$leftShadow.addClass(that.settings.visibleClass);
            that.$navLeft.addClass(that.settings.visibleClass)
        }else if(that.plugin.wrapScrollPos < that.settings.sideScrollShadowShowPosition && that.leftShadowVisible){
            that.leftShadowVisible = false;
            that.$leftShadow.removeClass(that.settings.visibleClass);
            that.$navLeft.removeClass(that.settings.visibleClass)
        }
        //right
        var maxLeftScroll = that.plugin.getTableWith()  - that.plugin.$wrap.width();

        if(that.plugin.wrapScrollPos >= maxLeftScroll && that.rightShadowVisible){
            that.rightShadowVisible = false;
            that.$rightShadow.removeClass(that.settings.visibleClass);
            that.$navRight.removeClass(that.plugin.settings.visibleClass);
        }else if(that.plugin.wrapScrollPos < maxLeftScroll && !that.rightShadowVisible){
            that.rightShadowVisible = true;
            that.$rightShadow.addClass(that.settings.visibleClass);
            that.$navRight.addClass(that.plugin.settings.visibleClass);
        }


    }
    FixedSideTable.prototype.alignNav = function () {
        var that = this;
        var top = Math.min(that.plugin.scrollStopPos,
            Math.max(0, -that.plugin.tableTopViewOffset + that.plugin.topOffset) + that.plugin.$tableHeader.innerHeight() + $(window).height() * 0.3
        );
        if(top > that.plugin.tableHeight || top < 0){
            that.plugin.$navWrap.addClass("evin-nav-disabled");
        }else{
            that.plugin.$navWrap.removeClass("evin-nav-disabled");
            that.$navRight.css({
                top: top
            });
            that.$navLeft.css({
                top: top
            });
        }
    }

    //==============================================
    var FixedTopTable = function (plugin, options) {
        var that = this;
        that.top = 0;
        BaseFixedTable.call(that, plugin, options);
        that.init(options.topTableTpl);
    }
    FixedTopTable.prototype = Object.create(BaseFixedTable.prototype);
    FixedTopTable.prototype.init = function (template) {
        var that = this;
        that.createTable(template);

        //that.$tableHeader = that.plugin.$table.find("thead");
        that.topOffset = -1;
        that.$tableHeaderThs = that.plugin.$tableHeader.find("th");
        that.$tableHeader = that.plugin.$tableHeader.clone();
        that.$fixedTopTableHeaderThs = that.$tableHeader.find("th")
        that.$table.prepend(that.$tableHeader);

        that.resize();
    }
    FixedTopTable.prototype.resize = function () {
        var that = this;
        if(
            that.$table.width() != that.plugin.$table.width()
            ||
            that.$tableHeader.height() != that.plugin.$tableHeader.height()
        ){
            that.$tableHeaderThs.each(function (index, el) {
                that.$fixedTopTableHeaderThs.eq(index).css({
                    width: $(el).outerWidth(),
                    minWidth: $(el).outerWidth(),
                    maxWidth: $(el).outerWidth(),
                    height: $(el).outerHeight()
                })
            })
            that.$table.css({
                width: that.plugin.$table.width()
            });
        }
    }
    FixedTopTable.prototype.onWrapScroll = function () {
        var that = this;
        if(that.isFixed()){
            that.$table.css({
                left: -that.plugin.$wrap.scrollLeft()
            });
        }else{
            that.$table.css({
                left: 0
            });
        }
    }
    FixedTopTable.prototype.onWindowScroll = function () {
        var that = this;
        that.resize();

        that.top = Math.max(0, -that.plugin.tableTopViewOffset + that.plugin.topOffset);

        //check if visible
        if(that.top > that.settings.topScrollShadowShowPosition && !that.isVisible()){
            that.$wrap.addClass(that.plugin.settings.visibleClass);
        }else if(that.top < that.settings.topScrollShadowShowPosition && that.isVisible()){
            that.$wrap.removeClass(that.plugin.settings.visibleClass);
        }

        //check if fixed
        if(that.isVisible()){
            if(that.top > that.plugin.scrollStopPos){
                that.top = that.plugin.scrollStopPos;
                if(that.isFixed()){
                    that.disableFixing(that.top);
                }else{
                    that.$wrap.css({
                        top: that.top,
                        left: Math.max(0, that.plugin.$table.parent().position().left),
                    });
                }
            }else if(that.top < that.plugin.scrollStopPos && !that.isFixed()){
                that.enableFixing();
            }
        }

        if(this.topOffset != that.plugin.topOffset && that.isFixed()){
            that.updateFixedTop();
        }
    }
    FixedTopTable.prototype.onWindowResize = function () {
        var that = this;
        that.onWindowScroll();
        if(that.isFixed()){
            that.$wrap.css({
                left: Math.max(that.plugin.$table.offset().left, that.plugin.$wrap.offset().left),
                width: Math.min(that.plugin.$table.outerWidth(), that.plugin.$wrap.innerWidth())
            });
        }else{
            that.$wrap.css({
                left: Math.max(0, that.plugin.$table.parent().position().left),
            });
        }
    }
    FixedTopTable.prototype.updateFixedTop = function () {
        var that = this;
        that.$wrap.css({
            top: that.plugin.topOffset
        })
        that.topOffset = that.plugin.topOffset;
    }
    FixedTopTable.prototype.enableFixing = function () {
        var that = this;
        that.$wrap.addClass(that.plugin.settings.fixedClass).css({
            left: Math.max(that.plugin.$table.offset().left, that.plugin.$wrap.offset().left),
            width: Math.min(that.plugin.$table.outerWidth(), that.plugin.$wrap.innerWidth())
        });
        that.updateFixedTop();
        that.onWrapScroll();
    }
    FixedTopTable.prototype.disableFixing = function (top) {
        var that = this;
        that.$wrap.removeClass(that.plugin.settings.fixedClass).css({
            top: top,
            left: Math.max(0, that.plugin.$table.parent().position().left),
            width: 'auto'
        });
        that.onWrapScroll();
    }
    $.fn.evinTableScroll = function( options ) {

        if (this.length === 0) {
            return this;
        }

        if (this.length > 1) {
            this.each(function () {
                $(this).evinTableScroll(options);
            });
            return this;
        }
        //==============================================

        //==============================================

        var settings = $.extend(true, {}, defaults, options)
        ;

        var plugin = {
            settings: settings,
            $table: this,
            $tableHeader: this.find("thead"),
            $wrap: settings.scrollableWrap || this.parent(),
            fixedTopTable: null,
            fixedSideTable: null,
            fixedCornerTable: null,
            bodyScrollTop: 0,
            scrollStopPos: 0,
            topOffset: 0,
            tableTopViewOffset: 0,
            wrapScrollPos: 0,
            tableHeight: 0,
            init: function () {
                var $this = this;
                $this.$navWrap = $(settings.navWrapTpl);
                $this.$wrap.after($this.$navWrap);
                $this.$navWrap.append($this.$wrap);

                if($this.$table.data("freeze_top")){
                    $this.fixedTopTable = new FixedTopTable($this, settings);
                }

                if(
                    $this.$table.find("tbody th").length && $this.$table.data("freeze_side")
                ){
                    $this.fixedSideTable = new FixedSideTable($this, settings);
                    if($this.fixedTopTable){
                        $this.fixedCornerTable = new FixedCornerTable($this, settings);
                    }

                }

                $this.onWindowResize();
                $this.onWindowScroll();
                $this.onWrapScroll();
            },
            onWindowScroll: function () {
                var $this = this;
                $this.bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                $this.tableTopViewOffset = $this.calculateTableViewOffset();

                $this.scrollStopPos = $this.tableHeight - $this.settings.topScrollStop;

                if(typeof $this.settings.topScrollTopOffset === "function"){
                    $this.topOffset = $this.settings.topScrollTopOffset();
                }else if($this.settings.topScrollTopOffset){
                    $this.topOffset = $this.settings.topScrollTopOffset;
                }else{
                    $this.topOffset = 0;
                }

                if($this.fixedTopTable){
                    $this.fixedTopTable.onWindowScroll();
                }
                if($this.fixedSideTable){
                    $this.fixedSideTable.onWindowScroll();
                }
                if($this.fixedCornerTable){
                    $this.fixedCornerTable.onWindowScroll();
                }
            },
            onWrapScroll: function () {
                var $this = this;
                $this.wrapScrollPos = $this.$wrap.scrollLeft();

                if($this.fixedSideTable){
                    $this.fixedSideTable.onWrapScroll();
                }
                if($this.fixedTopTable){
                    $this.fixedTopTable.onWrapScroll();
                }
                if($this.fixedCornerTable){
                    $this.fixedCornerTable.onWrapScroll();
                }
            },
            onWindowResize: function () {
                var $this = this;
                $this.tableHeight = $this.$table.outerHeight();
                $this.tableWidth = $this.$table.innerWidth();
                $this.wrapScrollPos = $this.$wrap.scrollLeft();

                if($this.fixedSideTable){
                    $this.fixedSideTable.onWindowResize();
                }
                if($this.fixedTopTable){
                    $this.fixedTopTable.onWindowResize();
                }
                if($this.fixedCornerTable){
                    $this.fixedCornerTable.onWindowResize();
                }
            },
            calculateTableViewOffset: function () {
                var $this = this;
                return $this.$table.offset().top - $this.bodyScrollTop;
            },
            getTableWith(){
                var $this = this;
                if($this.tableWidth === 0){
                    $this.tableWidth = Math.round($this.$table.innerWidth());
                }
                return $this.tableWidth;
            }
        };
        plugin.init();

        var resizeTimeout;
        
        $(window).on('resize orientationchange', function (e) {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
                plugin.onWindowResize();
            }, 200);
        });
        $(window).on('scroll', function(){
            plugin.onWindowScroll();
        });
        plugin.$wrap.on("scroll", function () {
            plugin.onWrapScroll();
        });

        this.update = function () {
            plugin.onWindowResize();
            plugin.onWrapScroll();
        }
        this.redrawSide = function () {
            if(plugin.fixedSideTable){
                plugin.fixedSideTable.redraw();
            }
        }

        return this;
    };

}(jQuery));